// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><g fill=\"%23ffffff\" fill-opacity=\"0.05\"><circle cx=\"30\" cy=\"30\" r=\"2\"/></g></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><g fill=\"%23667eea\" fill-opacity=\"0.03\"><rect width=\"2\" height=\"2\" x=\"19\" y=\"19\"/></g></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Landing Page Styles */
.landing-page {
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  background: #f8fafc;
}

/* Navigation */
.landing-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
}

/* Scrolled state for navigation */
.landing-nav.scrolled {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  position: fixed;
  padding: 1rem 2rem;
}

.nav-logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

/* Logo color when scrolled */
.landing-nav.scrolled .nav-logo {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: none;
}

.logo-icon {
  font-size: 1.8rem;
  filter: drop-shadow(0 2px 4px rgba(255, 255, 255, 0.2));
  transition: all 0.3s ease;
}

.landing-nav.scrolled .logo-icon {
  filter: drop-shadow(0 2px 4px rgba(102, 126, 234, 0.3));
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-links a {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  position: relative;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.nav-links a:hover {
  color: white;
  transform: translateY(-1px);
}

/* Link colors when scrolled */
.landing-nav.scrolled .nav-links a {
  color: #64748b;
  text-shadow: none;
}

.landing-nav.scrolled .nav-links a:hover {
  color: #667eea;
}

.nav-links a::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: -4px;
  left: 50%;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.nav-links a:hover::after {
  width: 100%;
}

/* Underline color when scrolled */
.landing-nav.scrolled .nav-links a::after {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.nav-signin-btn {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 0.75rem 1.5rem;
  border-radius: 0.75rem;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.nav-signin-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Sign in button when scrolled */
.landing-nav.scrolled .nav-signin-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: 2px solid transparent;
  box-shadow: 0 4px 14px rgba(102, 126, 234, 0.3);
  text-shadow: none;
}

.landing-nav.scrolled .nav-signin-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: transparent;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8rem 2rem 6rem;
  text-align: center;
  min-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat;
  pointer-events: none;
}

.hero-content {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.hero-content h1 {
  font-size: 4rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.hero-content h2 {
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 1.5rem;
  opacity: 0.95;
  line-height: 1.4;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.hero-content p {
  font-size: 1.1rem;
  margin-bottom: 2.5rem;
  opacity: 0.85;
  line-height: 1.6;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.hero-cta-button {
  background: rgba(255, 255, 255, 0.95);
  color: #667eea;
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  margin-top: 1rem;
}

.hero-cta-button:hover {
  background: white;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.hero-cta-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.hero-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary {
  background: rgba(255, 255, 255, 0.95);
  color: #667eea;
  border: none;
  padding: 1rem 2.5rem;
  border-radius: 0.75rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.btn-primary:hover {
  background: white;
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 1rem 2.5rem;
  border-radius: 0.75rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
}

/* Container */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* How It Works Section */
.how-it-works-section {
  padding: 6rem 0;
  background: linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%);
  position: relative;
}

.how-it-works-section h2 {
  text-align: center;
  font-size: 2.75rem;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1rem;
  letter-spacing: -0.02em;
}

.section-subtitle {
  text-align: center;
  font-size: 1.2rem;
  color: #64748b;
  line-height: 1.7;
  max-width: 700px;
  margin: 0 auto 3rem;
}

/* Video Container */
.video-container {
  margin: 3rem 0 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-wrapper {
  position: relative;
  width: 100%;
  max-width: 900px;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
  border-radius: 1rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  background: #000;
}

.video-embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 1rem;
}

/* Steps */
.how-it-works-steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2.5rem;
  margin-top: 4rem;
}

.step-card {
  background: white;
  padding: 2.5rem 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  text-align: center;
  border: 1px solid #e2e8f0;
  position: relative;
}

.step-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(102, 126, 234, 0.15);
  border-color: #667eea;
}

.step-number {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 1.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.step-card h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;
}

.step-card p {
  font-size: 1rem;
  color: #64748b;
  line-height: 1.7;
  margin: 0;
}

/* Responsive Video */
@media (max-width: 768px) {
  .how-it-works-section {
    padding: 4rem 0;
  }

  .how-it-works-section h2 {
    font-size: 2rem;
  }

  .section-subtitle {
    font-size: 1rem;
    padding: 0 1rem;
  }

  .video-container {
    margin: 2rem 0 3rem;
    padding: 0 1rem;
  }

  .video-wrapper {
    border-radius: 0.75rem;
  }

  .how-it-works-steps {
    grid-template-columns: 1fr;
    gap: 2rem;
    margin-top: 3rem;
    padding: 0 1rem;
  }

  .step-card {
    padding: 2rem 1.5rem;
  }

  .step-number {
    width: 50px;
    height: 50px;
    font-size: 1.5rem;
  }

  .step-card h3 {
    font-size: 1.25rem;
  }
}

/* About Section */
.about-section {
  padding: 6rem 0;
  background: white;
  position: relative;
}

.about-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
}

.about-section h2 {
  text-align: center;
  font-size: 2.75rem;
  font-weight: 700;
  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
}

.about-section > .container > p {
  text-align: center;
  font-size: 1.2rem;
  color: #64748b;
  max-width: 800px;
  margin: 0 auto 4rem;
  line-height: 1.7;
  font-weight: 400;
}

/* Testimonials Section */
.testimonials-section {
  padding: 6rem 0;
  background: #f8fafc;
  position: relative;
}

.testimonials-section h2 {
  text-align: center;
  font-size: 2.75rem;
  font-weight: 700;
  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 3rem;
  letter-spacing: -0.02em;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.testimonial-card {
  background: white;
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #e2e8f0;
}

.testimonial-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.testimonial-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.testimonial-text {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #475569;
  font-style: italic;
  margin: 0;
}

.testimonial-author {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.testimonial-author strong {
  font-size: 1.1rem;
  color: #1e293b;
  font-weight: 600;
}

.testimonial-author span {
  font-size: 0.95rem;
  color: #64748b;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2.5rem;
  margin-top: 4rem;
}

.feature-card {
  background: white;
  padding: 2.5rem;
  border-radius: 1.5rem;
  text-align: center;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.feature-card:hover::before {
  transform: scaleX(1);
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.15);
  border-color: #cbd5e1;
}

.feature-icon {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  display: block;
  filter: drop-shadow(0 4px 8px rgba(102, 126, 234, 0.2));
}

.feature-card h3 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;
  letter-spacing: -0.01em;
}

.feature-card p {
  color: #64748b;
  line-height: 1.6;
  font-size: 1rem;
}

/* Coming Soon Section */
.coming-soon-section {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 6rem 0;
  text-align: center;
  position: relative;
}

.coming-soon-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) repeat;
  pointer-events: none;
}

.coming-soon-section h2 {
  font-size: 2.75rem;
  font-weight: 700;
  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
  position: relative;
  z-index: 1;
}

.coming-soon-section p {
  font-size: 1.2rem;
  color: #64748b;
  max-width: 650px;
  margin: 0 auto 4rem;
  line-height: 1.7;
  position: relative;
  z-index: 1;
}

.beta-benefits {
  display: flex;
  justify-content: center;
  gap: 4rem;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
}

.benefit {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  min-width: 140px;
}

.benefit:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(102, 126, 234, 0.15);
}

.benefit-icon {
  font-size: 2.5rem;
  filter: drop-shadow(0 2px 4px rgba(102, 126, 234, 0.2));
}

.benefit span:last-child {
  font-weight: 600;
  color: #1e293b;
  font-size: 0.95rem;
}

/* Team Section */
.team-section {
  padding: 6rem 0;
  background: white;
}

.team-section h2 {
  text-align: center;
  font-size: 2.75rem;
  font-weight: 700;
  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
}

.team-section > .container > p {
  text-align: center;
  font-size: 1.2rem;
  color: #64748b;
  max-width: 600px;
  margin: 0 auto 4rem;
  line-height: 1.7;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2.5rem;
  margin-top: 4rem;
}

.team-member {
  background: white;
  padding: 2.5rem;
  border-radius: 1.5rem;
  text-align: center;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.team-member::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.team-member:hover::before {
  transform: scaleX(1);
}

.team-member:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.15);
}

.member-photo {
  margin-bottom: 1.5rem;
}

.member-photo img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e2e8f0;
  transition: all 0.3s ease;
}

.team-member:hover .member-photo img {
  border-color: #667eea;
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.2);
}

.member-info h3 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.5rem;
  letter-spacing: -0.01em;
}

.member-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 500;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.member-bio {
  color: #64748b;
  line-height: 1.6;
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
}

.member-social {
  margin-top: 1rem;
}

.linkedin-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #0077b5;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0.75rem 1.25rem;
  border: 1px solid #0077b5;
  border-radius: 0.75rem;
  transition: all 0.3s ease;
  background: rgba(0, 119, 181, 0.05);
}

.linkedin-link:hover {
  background: #0077b5;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 119, 181, 0.3);
}

.linkedin-link svg {
  width: 16px;
  height: 16px;
}

/* Beta Signup Section */
.beta-signup-section {
  padding: 6rem 0;
  background: white;
  position: relative;
}

.beta-signup-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
}

.beta-signup-section h2 {
  text-align: center;
  font-size: 2.75rem;
  font-weight: 700;
  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
}

.beta-signup-section > .container > p {
  text-align: center;
  font-size: 1.2rem;
  color: #64748b;
  margin-bottom: 4rem;
  line-height: 1.6;
}

.beta-form {
  max-width: 650px;
  margin: 0 auto;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  padding: 3rem;
  border-radius: 1.5rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.1);
  position: relative;
}

.beta-form::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 1.5rem 1.5rem 0 0;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.75rem;
  font-weight: 600;
  color: #374151;
  font-size: 0.95rem;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}

.submit-btn {
  width: 100%;
  margin-top: 2rem;
  padding: 1.25rem;
  font-size: 1.1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 0.75rem;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.success-message {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #065f46;
  padding: 1.25rem;
  border-radius: 0.75rem;
  margin-top: 1.5rem;
  text-align: center;
  font-weight: 500;
  border: 1px solid #a7f3d0;
}

.error-message {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #991b1b;
  padding: 1.25rem;
  border-radius: 0.75rem;
  margin-top: 1.5rem;
  text-align: center;
  font-weight: 500;
  border: 1px solid #fecaca;
}

/* Footer */
.landing-footer {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  color: white;
  padding: 4rem 0 2rem;
  position: relative;
}

.landing-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  margin-bottom: 3rem;
}

.footer-section h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.footer-section p,
.footer-section a {
  color: #cbd5e1;
  text-decoration: none;
  line-height: 1.6;
  transition: color 0.2s ease;
}

.footer-section a {
  display: block;
  margin-bottom: 0.5rem;
}

.footer-section a:hover {
  color: white;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 2rem;
  text-align: center;
  color: #94a3b8;
}

/* Responsive Design */
@media (max-width: 768px) {
  .landing-nav {
    padding: 1rem;
  }
  
  .nav-links {
    gap: 1rem;
  }
  
  .hero-content h1 {
    font-size: 2.75rem;
  }
  
  .hero-content h2 {
    font-size: 1.3rem;
  }
  
  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .beta-benefits {
    flex-direction: column;
    gap: 2rem;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
  }
  
  .team-grid {
    grid-template-columns: 1fr;
  }
  
  .about-section h2,
  .coming-soon-section h2,
  .team-section h2,
  .beta-signup-section h2,
  .testimonials-section h2 {
    font-size: 2.25rem;
  }
  
  .testimonials-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .hero-section {
    padding: 6rem 1rem 4rem;
  }
  
  .container {
    padding: 0 1rem;
  }
  
  .beta-form {
    padding: 2rem;
  }
  
  .hero-content h1 {
    font-size: 2.25rem;
  }
  
  .hero-cta-button {
    padding: 0.875rem 2rem;
    font-size: 1rem;
  }
  
  .feature-card,
  .team-member,
  .testimonial-card {
    padding: 2rem;
  }
  
  .testimonials-section h2 {
    font-size: 2rem;
  }
  
  .testimonials-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LandingPage.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,iHAAiH;EACjH,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,wCAAwC;EACxC,iDAAiD;EACjD,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,uDAAuD;EACvD,yBAAyB;AAC3B;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,iCAAiC;AACjC;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,6DAA6D;EAC7D,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0DAAoP;EACpP,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,gEAAgE;EAChE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sBAAsB,EAAE,sBAAsB;EAC9C,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qEAAqE;AACvE;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iFAAiF;EACjF,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qFAAqF;AACvF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0DAA+P;EAC/P,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qEAAqE;AACvE;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6EAA6E;EAC7E,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sFAAsF;AACxF;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;;IAKE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;AACF","sourcesContent":["/* Modern Landing Page Styles */\n.landing-page {\n  min-height: 100vh;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n  background: #f8fafc;\n}\n\n/* Navigation */\n.landing-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 2rem;\n  background: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  transition: all 0.3s ease;\n}\n\n/* Scrolled state for navigation */\n.landing-nav.scrolled {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n  position: fixed;\n  padding: 1rem 2rem;\n}\n\n.nav-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: white;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n/* Logo color when scrolled */\n.landing-nav.scrolled .nav-logo {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-shadow: none;\n}\n\n.logo-icon {\n  font-size: 1.8rem;\n  filter: drop-shadow(0 2px 4px rgba(255, 255, 255, 0.2));\n  transition: all 0.3s ease;\n}\n\n.landing-nav.scrolled .logo-icon {\n  filter: drop-shadow(0 2px 4px rgba(102, 126, 234, 0.3));\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.nav-links a {\n  text-decoration: none;\n  color: rgba(255, 255, 255, 0.9);\n  font-weight: 500;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  position: relative;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.nav-links a:hover {\n  color: white;\n  transform: translateY(-1px);\n}\n\n/* Link colors when scrolled */\n.landing-nav.scrolled .nav-links a {\n  color: #64748b;\n  text-shadow: none;\n}\n\n.landing-nav.scrolled .nav-links a:hover {\n  color: #667eea;\n}\n\n.nav-links a::after {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 2px;\n  bottom: -4px;\n  left: 50%;\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  transform: translateX(-50%);\n}\n\n.nav-links a:hover::after {\n  width: 100%;\n}\n\n/* Underline color when scrolled */\n.landing-nav.scrolled .nav-links a::after {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.nav-signin-btn {\n  background: rgba(255, 255, 255, 0.15);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.75rem;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.nav-signin-btn:hover {\n  background: rgba(255, 255, 255, 0.25);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Sign in button when scrolled */\n.landing-nav.scrolled .nav-signin-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border: 2px solid transparent;\n  box-shadow: 0 4px 14px rgba(102, 126, 234, 0.3);\n  text-shadow: none;\n}\n\n.landing-nav.scrolled .nav-signin-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-color: transparent;\n}\n\n/* Hero Section */\n.hero-section {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 8rem 2rem 6rem;\n  text-align: center;\n  min-height: 85vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.hero-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><g fill=\"%23ffffff\" fill-opacity=\"0.05\"><circle cx=\"30\" cy=\"30\" r=\"2\"/></g></svg>') repeat;\n  pointer-events: none;\n}\n\n.hero-content {\n  max-width: 900px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.hero-content h1 {\n  font-size: 4rem;\n  font-weight: 800;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.02em;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.hero-content h2 {\n  font-size: 1.5rem;\n  font-weight: 400;\n  margin-bottom: 1.5rem;\n  opacity: 0.95;\n  line-height: 1.4;\n  max-width: 700px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.hero-content p {\n  font-size: 1.1rem;\n  margin-bottom: 2.5rem;\n  opacity: 0.85;\n  line-height: 1.6;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.hero-cta-button {\n  background: rgba(255, 255, 255, 0.95);\n  color: #667eea;\n  border: none;\n  padding: 1rem 2.5rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  margin-top: 1rem;\n}\n\n.hero-cta-button:hover {\n  background: white;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n.hero-cta-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n.hero-buttons {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.btn-primary {\n  background: rgba(255, 255, 255, 0.95);\n  color: #667eea;\n  border: none;\n  padding: 1rem 2.5rem;\n  border-radius: 0.75rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-block;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n}\n\n.btn-primary:hover {\n  background: white;\n  transform: translateY(-3px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.btn-secondary {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  padding: 1rem 2.5rem;\n  border-radius: 0.75rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-2px);\n}\n\n/* Container */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n/* How It Works Section */\n.how-it-works-section {\n  padding: 6rem 0;\n  background: linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%);\n  position: relative;\n}\n\n.how-it-works-section h2 {\n  text-align: center;\n  font-size: 2.75rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 1rem;\n  letter-spacing: -0.02em;\n}\n\n.section-subtitle {\n  text-align: center;\n  font-size: 1.2rem;\n  color: #64748b;\n  line-height: 1.7;\n  max-width: 700px;\n  margin: 0 auto 3rem;\n}\n\n/* Video Container */\n.video-container {\n  margin: 3rem 0 5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.video-wrapper {\n  position: relative;\n  width: 100%;\n  max-width: 900px;\n  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */\n  height: 0;\n  overflow: hidden;\n  border-radius: 1rem;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  background: #000;\n}\n\n.video-embed {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 1rem;\n}\n\n/* Steps */\n.how-it-works-steps {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2.5rem;\n  margin-top: 4rem;\n}\n\n.step-card {\n  background: white;\n  padding: 2.5rem 2rem;\n  border-radius: 1rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  text-align: center;\n  border: 1px solid #e2e8f0;\n  position: relative;\n}\n\n.step-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 12px 40px rgba(102, 126, 234, 0.15);\n  border-color: #667eea;\n}\n\n.step-number {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  font-size: 1.75rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1.5rem;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.step-card h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 1rem;\n}\n\n.step-card p {\n  font-size: 1rem;\n  color: #64748b;\n  line-height: 1.7;\n  margin: 0;\n}\n\n/* Responsive Video */\n@media (max-width: 768px) {\n  .how-it-works-section {\n    padding: 4rem 0;\n  }\n\n  .how-it-works-section h2 {\n    font-size: 2rem;\n  }\n\n  .section-subtitle {\n    font-size: 1rem;\n    padding: 0 1rem;\n  }\n\n  .video-container {\n    margin: 2rem 0 3rem;\n    padding: 0 1rem;\n  }\n\n  .video-wrapper {\n    border-radius: 0.75rem;\n  }\n\n  .how-it-works-steps {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    margin-top: 3rem;\n    padding: 0 1rem;\n  }\n\n  .step-card {\n    padding: 2rem 1.5rem;\n  }\n\n  .step-number {\n    width: 50px;\n    height: 50px;\n    font-size: 1.5rem;\n  }\n\n  .step-card h3 {\n    font-size: 1.25rem;\n  }\n}\n\n/* About Section */\n.about-section {\n  padding: 6rem 0;\n  background: white;\n  position: relative;\n}\n\n.about-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, #e2e8f0, transparent);\n}\n\n.about-section h2 {\n  text-align: center;\n  font-size: 2.75rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.02em;\n}\n\n.about-section > .container > p {\n  text-align: center;\n  font-size: 1.2rem;\n  color: #64748b;\n  max-width: 800px;\n  margin: 0 auto 4rem;\n  line-height: 1.7;\n  font-weight: 400;\n}\n\n/* Testimonials Section */\n.testimonials-section {\n  padding: 6rem 0;\n  background: #f8fafc;\n  position: relative;\n}\n\n.testimonials-section h2 {\n  text-align: center;\n  font-size: 2.75rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 3rem;\n  letter-spacing: -0.02em;\n}\n\n.testimonials-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.testimonial-card {\n  background: white;\n  border-radius: 16px;\n  padding: 2.5rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 1px solid #e2e8f0;\n}\n\n.testimonial-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.testimonial-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.testimonial-text {\n  font-size: 1.1rem;\n  line-height: 1.7;\n  color: #475569;\n  font-style: italic;\n  margin: 0;\n}\n\n.testimonial-author {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.testimonial-author strong {\n  font-size: 1.1rem;\n  color: #1e293b;\n  font-weight: 600;\n}\n\n.testimonial-author span {\n  font-size: 0.95rem;\n  color: #64748b;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 2.5rem;\n  margin-top: 4rem;\n}\n\n.feature-card {\n  background: white;\n  padding: 2.5rem;\n  border-radius: 1.5rem;\n  text-align: center;\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  position: relative;\n  overflow: hidden;\n}\n\n.feature-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n\n.feature-card:hover::before {\n  transform: scaleX(1);\n}\n\n.feature-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.15);\n  border-color: #cbd5e1;\n}\n\n.feature-icon {\n  font-size: 3.5rem;\n  margin-bottom: 1.5rem;\n  display: block;\n  filter: drop-shadow(0 4px 8px rgba(102, 126, 234, 0.2));\n}\n\n.feature-card h3 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 1rem;\n  letter-spacing: -0.01em;\n}\n\n.feature-card p {\n  color: #64748b;\n  line-height: 1.6;\n  font-size: 1rem;\n}\n\n/* Coming Soon Section */\n.coming-soon-section {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  padding: 6rem 0;\n  text-align: center;\n  position: relative;\n}\n\n.coming-soon-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><g fill=\"%23667eea\" fill-opacity=\"0.03\"><rect width=\"2\" height=\"2\" x=\"19\" y=\"19\"/></g></svg>') repeat;\n  pointer-events: none;\n}\n\n.coming-soon-section h2 {\n  font-size: 2.75rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.02em;\n  position: relative;\n  z-index: 1;\n}\n\n.coming-soon-section p {\n  font-size: 1.2rem;\n  color: #64748b;\n  max-width: 650px;\n  margin: 0 auto 4rem;\n  line-height: 1.7;\n  position: relative;\n  z-index: 1;\n}\n\n.beta-benefits {\n  display: flex;\n  justify-content: center;\n  gap: 4rem;\n  flex-wrap: wrap;\n  position: relative;\n  z-index: 1;\n}\n\n.benefit {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.5rem;\n  background: white;\n  border-radius: 1rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n  min-width: 140px;\n}\n\n.benefit:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 24px rgba(102, 126, 234, 0.15);\n}\n\n.benefit-icon {\n  font-size: 2.5rem;\n  filter: drop-shadow(0 2px 4px rgba(102, 126, 234, 0.2));\n}\n\n.benefit span:last-child {\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 0.95rem;\n}\n\n/* Team Section */\n.team-section {\n  padding: 6rem 0;\n  background: white;\n}\n\n.team-section h2 {\n  text-align: center;\n  font-size: 2.75rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.02em;\n}\n\n.team-section > .container > p {\n  text-align: center;\n  font-size: 1.2rem;\n  color: #64748b;\n  max-width: 600px;\n  margin: 0 auto 4rem;\n  line-height: 1.7;\n}\n\n.team-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 2.5rem;\n  margin-top: 4rem;\n}\n\n.team-member {\n  background: white;\n  padding: 2.5rem;\n  border-radius: 1.5rem;\n  text-align: center;\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  position: relative;\n  overflow: hidden;\n}\n\n.team-member::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n\n.team-member:hover::before {\n  transform: scaleX(1);\n}\n\n.team-member:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.15);\n}\n\n.member-photo {\n  margin-bottom: 1.5rem;\n}\n\n.member-photo img {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid #e2e8f0;\n  transition: all 0.3s ease;\n}\n\n.team-member:hover .member-photo img {\n  border-color: #667eea;\n  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.2);\n}\n\n.member-info h3 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 0.5rem;\n  letter-spacing: -0.01em;\n}\n\n.member-title {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-weight: 500;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n\n.member-bio {\n  color: #64748b;\n  line-height: 1.6;\n  font-size: 0.95rem;\n  margin-bottom: 1.5rem;\n}\n\n.member-social {\n  margin-top: 1rem;\n}\n\n.linkedin-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #0077b5;\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  padding: 0.75rem 1.25rem;\n  border: 1px solid #0077b5;\n  border-radius: 0.75rem;\n  transition: all 0.3s ease;\n  background: rgba(0, 119, 181, 0.05);\n}\n\n.linkedin-link:hover {\n  background: #0077b5;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 119, 181, 0.3);\n}\n\n.linkedin-link svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Beta Signup Section */\n.beta-signup-section {\n  padding: 6rem 0;\n  background: white;\n  position: relative;\n}\n\n.beta-signup-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, #e2e8f0, transparent);\n}\n\n.beta-signup-section h2 {\n  text-align: center;\n  font-size: 2.75rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.02em;\n}\n\n.beta-signup-section > .container > p {\n  text-align: center;\n  font-size: 1.2rem;\n  color: #64748b;\n  margin-bottom: 4rem;\n  line-height: 1.6;\n}\n\n.beta-form {\n  max-width: 650px;\n  margin: 0 auto;\n  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\n  padding: 3rem;\n  border-radius: 1.5rem;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.1);\n  position: relative;\n}\n\n.beta-form::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 1.5rem 1.5rem 0 0;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.75rem;\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.95rem;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 1rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  background: white;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);\n  transform: translateY(-1px);\n}\n\n.submit-btn {\n  width: 100%;\n  margin-top: 2rem;\n  padding: 1.25rem;\n  font-size: 1.1rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border: none;\n  border-radius: 0.75rem;\n  color: white;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n.submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.success-message {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  color: #065f46;\n  padding: 1.25rem;\n  border-radius: 0.75rem;\n  margin-top: 1.5rem;\n  text-align: center;\n  font-weight: 500;\n  border: 1px solid #a7f3d0;\n}\n\n.error-message {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  color: #991b1b;\n  padding: 1.25rem;\n  border-radius: 0.75rem;\n  margin-top: 1.5rem;\n  text-align: center;\n  font-weight: 500;\n  border: 1px solid #fecaca;\n}\n\n/* Footer */\n.landing-footer {\n  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);\n  color: white;\n  padding: 4rem 0 2rem;\n  position: relative;\n}\n\n.landing-footer::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 3rem;\n  margin-bottom: 3rem;\n}\n\n.footer-section h3 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.footer-section p,\n.footer-section a {\n  color: #cbd5e1;\n  text-decoration: none;\n  line-height: 1.6;\n  transition: color 0.2s ease;\n}\n\n.footer-section a {\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n.footer-section a:hover {\n  color: white;\n}\n\n.footer-bottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding-top: 2rem;\n  text-align: center;\n  color: #94a3b8;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .landing-nav {\n    padding: 1rem;\n  }\n  \n  .nav-links {\n    gap: 1rem;\n  }\n  \n  .hero-content h1 {\n    font-size: 2.75rem;\n  }\n  \n  .hero-content h2 {\n    font-size: 1.3rem;\n  }\n  \n  .hero-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .form-row {\n    grid-template-columns: 1fr;\n  }\n  \n  .beta-benefits {\n    flex-direction: column;\n    gap: 2rem;\n  }\n  \n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .team-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .about-section h2,\n  .coming-soon-section h2,\n  .team-section h2,\n  .beta-signup-section h2,\n  .testimonials-section h2 {\n    font-size: 2.25rem;\n  }\n  \n  .testimonials-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-section {\n    padding: 6rem 1rem 4rem;\n  }\n  \n  .container {\n    padding: 0 1rem;\n  }\n  \n  .beta-form {\n    padding: 2rem;\n  }\n  \n  .hero-content h1 {\n    font-size: 2.25rem;\n  }\n  \n  .hero-cta-button {\n    padding: 0.875rem 2rem;\n    font-size: 1rem;\n  }\n  \n  .feature-card,\n  .team-member,\n  .testimonial-card {\n    padding: 2rem;\n  }\n  \n  .testimonials-section h2 {\n    font-size: 2rem;\n  }\n  \n  .testimonials-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
